class RangeSlider {
    /**
     * @param {jQuery} $element
     * @param {Object} options
     */
    constructor($element, options = {}) {
        this.$element = $element;

        this.options = Util.merge({
            numberFormat: true
        }, options);

        if (this.$element.data('range-slider')) {
            return;
        }

        // Instanz speichern
        this.$element.data('range-slider', this);

        this.$wrapper = $element.closest('.range-slider-wrapper');
        this.$range_from_input = $('.range_from_input', this.$wrapper);
        this.$range_to_input = $('.range_to_input', this.$wrapper);
        this.$range_from_input_visible = $('.range_from_input_visible', this.$wrapper);
        this.$range_to_input_visible = $('.range_to_input_visible', this.$wrapper);

        this.onChangeCallback = null;
        this.onChangedCallback = null;

        this._initialize();
    }

    setFrom(value) {
        this.valueFrom = value;

        if (this.valueTo != null) {
            this._setValues(this.valueFrom, this.valueTo);
        }
    }

    setTo(value) {
        this.valueTo = value;

        if (this.valueFrom != null) {
            this._setValues(this.valueFrom, this.valueTo);
        }
    }

    getSlider() {
        return this.$element;
    }

    /**
     * @private
     */
    _initialize() {
        let minValue = this.$element.data('min-slider-value');
        let maxValue = this.$element.data('max-slider-value');
        let steps = this.$element.data('step-slider-value');

        if (steps > maxValue) {
            steps = maxValue - 200;
        }

        let currentValueMin = this.$range_from_input_visible.data('current-value');
        let currentValueMax = this.$range_to_input_visible.data('current-value');

        this.$element.slider({
            range: true,
            min: minValue,
            max: maxValue,
            step: steps,
            values: [currentValueMin, currentValueMax],
            slide: $.proxy(this._onSlide, this),
            stop: $.proxy(this._onSlideStop, this)
        });

        this._redraw();
    }

    /**
     * @private
     */
    _onSlide(event, ui) {
        let range = {
            from: ui.values[0],
            to: ui.values[1]
        };
        let formattedRange = range;

        if (this.options.numberFormat) {
            formattedRange = {
                from: RangeSlider._formatRangeNumber(range.from),
                to: RangeSlider._formatRangeNumber(range.to)
            };
        }

        this.$range_from_input_visible.val(this.$range_from_input_visible.data('text-prefix') + formattedRange.from + this.$range_from_input_visible.data('text-suffix'));
        this.$range_to_input_visible.val(this.$range_to_input_visible.data('text-prefix') + formattedRange.to + this.$range_to_input_visible.data('text-suffix'));

        this.$range_from_input.val(range.from);
        this.$range_to_input.val(range.to);

        if (this.onChangeCallback) {
            let name = this.$element.data('element-name');
            this.onChangeCallback(name, range, this);
        }
    }

    /**
     * @private
     */
    _onSlideStop(event, ui) {
        let range = {
            from: ui.values[0],
            to: ui.values[1]
        };

        if (this.onChangedCallback) {
            let name = this.$element.data('element-name');
            this.onChangedCallback(name, range, this);
        }
    }

    /**
     * @private
     * Trigger slide to pre-fill input elements
     */
    _redraw() {
        this._onSlide(new $.Event(), {
            values: this.$element.slider('option', 'values')
        });
    }

    /**
     * @private
     */
    _setValues(first, second) {
        this.$element.slider('values', [first, second]);
        this._redraw();
    }

    static _formatRangeNumber(number, thousandsSeparator = '.') {
        return (number + '').replace(/\B(?=(?:\d{3})+(?!\d))/g, thousandsSeparator);
    }

    /**
     * @param {Function} callback
     */
    onChange(callback) {
        this.onChangeCallback = callback;
    }

    /**
     * @param {Function} callback
     */
    onChanged(callback) {
        this.onChangedCallback = callback;
    }
}
